// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCustomerserviceOutlinedSvg from "@fishx/icons-svg/es/asn/PCustomerserviceOutlined";
import FishxIcon from '../components/FishxIcon';

var PCustomerserviceOutlined = function PCustomerserviceOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCustomerserviceOutlinedSvg
  }));
};

PCustomerserviceOutlined.displayName = 'PCustomerserviceOutlined';
export default React.forwardRef(PCustomerserviceOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCustomerserviceOutlined.js
// module id = 3313
// module chunks = 0